import { useQuery } from '@apollo/client';
import { queryProductReviews } from '../../queries';
import { UseQueryProductReviewsProps } from '../../types';

const defaultParam = {
  sortBy: ['scoreDesc', 'createdAtDesc'],
  offset: 0,
  limit: 6,
  rating: [],
};

const useQueryProductReviews = (props: UseQueryProductReviewsProps) => {
  const { productId } = props;

  const query = useQuery(queryProductReviews, {
    variables: { ...defaultParam, productId },
    notifyOnNetworkStatusChange: true,
  });

  return { ...query, defaultParam };
};

export default useQueryProductReviews;
export { useQueryProductReviews, defaultParam };
